<template>
  <BuzzUserRegister />
</template>

<script>
import BuzzUserRegister from "@/components/BuzzUserRegister.vue";

export default {
  name: "DashboardUserRegisterView",
  components: {
    BuzzUserRegister,
  },
};
</script>
